import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import { PipeChat } from "../../shared";
import { CubeProvider } from "@cubejs-client/react";
import cubejs from "@cubejs-client/core";
import shadows from "@material-ui/core/styles/shadows";
import { CommonCss } from "../../services/CommonCss";
import Avatar from '@material-ui/core/Avatar';
import { getCookie } from "../../services/Cookies";
const useStyles = makeStyles((theme) => ({
  tabRoot: {
    backgroundColor: "#fff",
    opacity: 1,
    boxShadow: "0px 0px 6px 0px #c0c0c0!important",
    marginBottom: 2,
    marginTop: 2,
    marginLeft: 2,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    fontWeight: "bold",
    textTransform: "capitalize",
  },
  appBarRoot: {
    color: "#000",
    boxShadow: "0 0 0 red !important",
    backgroundColor: "transparent !important",
  },
  indicator: {
    border: "0 solid red",
    color: "red",
  },
  paper: {
    padding: "6px",
    // textAlign: "center",
    color: theme.palette.text.secondary,
    marginLeft: 2,
    borderTopLeftRadius: 0,
  },
  paperHeader: {
    backgroundColor: "transparent",
    boxShadow: " 0 0 0 0 #eee !important",
  },
  justifyContentBetween: {
    webkitBoxPack: " justify!important",
    msFlexPack: "justify!important",
    justifyContent: "space-between!important",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box px={3} pt={2} component="div">
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
/*
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}*/


export default function SampleStatus(props) {
  const classes = useStyles();
  const commonClasses = CommonCss();
  const history = useHistory();




  const [value, setValue] = React.useState(getDefaultTab()[0]);

  const handleChange = (event, newValue) => {
    //
    setValue(newValue);
    props.subType(newValue == 0 ? "Fuel" : newValue == 1 ? "Lube" : "Tot")
  };
  function getDefaultTab() {
    //

    const serviceTypes = getCookie("serviceTypes").split(',');
    const defaultTab = getCookie("defaultTab");
    let tabIndex = { Fuel: false, Lube: false, Tot: false };
    let tabOrder = [];
    if (!props.subValue) {
      props.subType(defaultTab);
    }

    serviceTypes.forEach((serviceType) => {
      // if(!props.subValue && serviceType=="Lube Analysis"  || serviceType=="OCM" || serviceType=="SDA" || serviceType=="Grease" || serviceType=="Compatibility" || serviceType=="Ferrography"){
      //   props.subType("Lube")
      // }else if(!props.subValue && serviceType=="TOT"){
      //   props.subType("Tot")
      // }else if(!props.subValue && serviceType=="FQT" || serviceType=="FSC" || serviceType=="FCA" || serviceType=="GCMS" || serviceType=="BQS"){
      //   props.subType("Fuel")
      // }
      if (serviceType == "TOT") {
        tabIndex.Tot = true;
        //props.subType("Tot")
      }
      if ((serviceType == "Lube Analysis" || serviceType == "OCM" || serviceType == "SDA" || serviceType == "Grease" || serviceType == "Compatibility" || serviceType == "Ferrography")) {
        tabIndex.Lube = true;
        //props.subType("Lube")
      }
      if ((serviceType == "FQT" || serviceType == "FSC" || serviceType == "FCA" || serviceType == "GCMS" || serviceType == "BQS")) {
        tabIndex.Fuel = true
        //props.subType("Fuel")
      }

    });
    if (typeof defaultTab != "undefined" && defaultTab != "" && defaultTab != null) {
      if (tabIndex[defaultTab] == true) {
        var tabi = 0;
        switch (defaultTab) {
          case 'Fuel':
            tabi = 0;
            break;
          case 'Lube':
            tabi = 1;
            break;
          case 'Tot':
            tabi = 2;
            break
        }
        tabOrder.push(tabi);
      }
    }
    if (tabIndex.Fuel == true && tabOrder.indexOf(0) == -1) {
      tabOrder.push(0);
    }
    if (tabIndex.Lube == true && tabOrder.indexOf(1) == -1) {
      tabOrder.push(1);
    }
    if (tabIndex.Tot == true && tabOrder.indexOf(2) == -1) {
      tabOrder.push(2);
    }
    //props.subType(tabOrder[0]==1?"Lube":"Tot")
    return tabOrder;


  }
  function a11yProps(index) {
    let showTab = false;
    if (getDefaultTab().indexOf(index) > -1)
      showTab = true;
    let res = {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`
    };
    if (!showTab) {

      res = {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
        "style": { display: "none" }
      };
    }

    return res;
  }


  const { sampleStatusDetails: { fuelAnalysisSampleStatus, lubeAnalysisSampleStatus, totAnalysisSampleStatus }, reportObj } = props;
  const fuelArray = fuelAnalysisSampleStatus.filter((row) => row.caseCount != 0);
  const lubeArray = lubeAnalysisSampleStatus.filter((row) => row.caseCount != 0);
  const totArray = totAnalysisSampleStatus.filter((row) => row.caseCount != 0);
  const fuelIcon = (value == 0 ? "assets/svg/fqt-new-1-selected.svg" : "assets/svg/fqt-new-1.svg");
  const lubeIcon = (value == 1 ? "assets/svg/ocm-new-selected.svg" : "assets/svg/ocm-new.svg");
  const TransIcon = (value == 2 ? "assets/svg/tot-new-selected.svg" : "assets/svg/tot-new.svg");
  function onReportDetails(data, type, subType,tab) {
    debugger
    console.log(tab)
    history.push({
      pathname: "/dashboard/sample-status",
      data: data,
      type: type,
      subType: subType,
      dashtab:tab
    });
  }
  return (
    <div className="samplestatus">
      <Box component="div" display="block">
        <Paper className={clsx(classes.paperHeader)}>
          <AppBar position="static" className={classes.appBarRoot}>
            <Tabs className="sample-stat-tab"
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
            >
              <Tab
                className={classes.tabRoot}
                label="Fuel Analysis"
                icon={<Avatar className="tab-ava-img" src={fuelIcon} />}
                {...a11yProps(0)}
              />
              <Tab
                className={classes.tabRoot}
                label="Lube Analysis"
                icon={<Avatar className="tab-ava-img" src={lubeIcon} />}
                {...a11yProps(1)}
              />
              <Tab
                className={classes.tabRoot}
                label="VPS Power"
                icon={<Avatar className="tab-ava-img" src={TransIcon} />}
                {...a11yProps(2)}
              />
            </Tabs>
          </AppBar>
        </Paper>
        <Paper className={classes.paper + " inpaper"}>
          <TabPanel value={value} index={0}>
            <Box component="div" display="flex" pb={2} alignItems="center">
              {fuelAnalysisSampleStatus.length && fuelArray.length
                ? fuelAnalysisSampleStatus[0].typeOfCase.map((item) => (
                  <Box key={item.title} className="tab-list-item" component="div" pr={2}>
                    <svg height="10" width="10">
                      <circle cx="5" cy="5" r="4" fill={item.color} />
                    </svg>
                    <Box component="span" pl={1}>
                      {item.title}
                    </Box>
                  </Box>
                ))
                : ""}
            </Box>
            <Box
              component="div"
              display="flex"
              style={{ cursor: "pointer" }}
            >
              {fuelAnalysisSampleStatus.length && fuelArray.length
                ? fuelAnalysisSampleStatus.map((item) => {
                  const itemList = item.typeOfCase.filter(item => item.value != 0);
                  return itemList.length ? (                
                    <Box
                      component="div"
                      style={{ cursor: "pointer" }}
                      key={item.title + Math.random() * 100}
                      onClick={() => {
                        onReportDetails(reportObj, "SampleStatus", "Fuel",value);

                      }}
                      px={3}
                    >
                      <PipeChat
                        typeOfCase={item.typeOfCase}
                        caseCount={item.caseCount}
                        text1={item.text1}
                        text2={item.text2}
                      />
                      <Box
                        component="span"
                        fontWeight="bold"
                        fontSize={20}
                        py={1}
                        display="block"
                        textAlign="center"
                      >
                        {item.title}
                      </Box>
                    </Box>
                  ) : ""
                })
                : (<Box height="194px" display="flex" justifyContent="center" className="full-w-align-c">
                  <Box className="bai-font" className="full-w-align-c">No Record Found</Box>
                </Box>)}
            </Box>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Box component="div" display="flex" pb={2} alignItems="center">
              {lubeAnalysisSampleStatus.length && lubeArray.length
                ? lubeAnalysisSampleStatus[0].typeOfCase.map((item) => (
                  <Box key={item.title} className="tab-list-item" component="div" pr={2}>
                    <svg height="10" width="10">
                      <circle cx="5" cy="5" r="4" fill={item.color} />
                    </svg>
                    <Box component="span" pl={1}>
                      {item.title}
                    </Box>
                  </Box>
                ))
                : ""}
            </Box>
            <Box
              component="div"
              display="flex"
              style={{ cursor: "pointer" }}
            >
              {lubeAnalysisSampleStatus.length && lubeArray.length
                ? lubeAnalysisSampleStatus.map((item) => {
                  const itemList = item.typeOfCase.filter(item => item.value != 0);
                  return itemList.length ? (
                    <Box
                      component="div"
                      style={{ cursor: "pointer" }}
                      key={item.title + Math.random() * 100}
                      onClick={() => {
                        onReportDetails(reportObj, "SampleStatus", "Lube",value);
                      }}
                      px={3}
                    >
                      <PipeChat
                        typeOfCase={item.typeOfCase}
                        caseCount={item.caseCount}
                        text1={item.text1}
                        text2={item.text2}
                      />
                      <Box
                        component="span"
                        fontWeight="bold"
                        fontSize={20}
                        py={1}
                        display="block"
                        textAlign="center"
                      >
                        {item.title}
                      </Box>
                    </Box>
                  ) : ""
                })
                : (<Box height="194px" display="flex" justifyContent="center">
                  <Box className="bai-font">No Record Found</Box>
                </Box>)}
            </Box>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Box component="div" display="flex" pb={2} alignItems="center">
              {totAnalysisSampleStatus.length && totArray.length
                ? totAnalysisSampleStatus[0].typeOfCase.map((item) => (
                  <Box key={item.title} className="tab-list-item" component="div" pr={2}>
                    <svg height="10" width="10">
                      <circle cx="5" cy="5" r="4" fill={item.color} />
                    </svg>
                    <Box component="span" pl={1}>
                      {item.title}
                    </Box>
                  </Box>
                ))
                : ""}
            </Box>
            <Box
              component="div"
              display="flex"
              style={{ cursor: "pointer" }}
            >
              {totAnalysisSampleStatus.length && totArray.length
                ? totAnalysisSampleStatus.map((item) => {
                  const itemList = item.typeOfCase.filter(item => item.value != 0);
                  return itemList.length ? (
                    <Box
                      component="div"
                      style={{ cursor: "pointer" }}
                      key={item.title + Math.random() * 100}
                      onClick={() => {
                        onReportDetails(reportObj, "SampleStatus", "Tot",value);
                      }}
                      px={3}
                    >
                      <PipeChat
                        typeOfCase={item.typeOfCase}
                        caseCount={item.caseCount}
                        text1={item.text1}
                        text2={item.text2}
                      />
                      <Box
                        component="span"
                        fontWeight="bold"
                        fontSize={20}
                        py={1}
                        display="block"
                        textAlign="center"
                      >
                        {item.title}
                      </Box>
                    </Box>
                  ) : ""
                })
                : (<Box height="194px" display="flex" justifyContent="center">
                  <Box className="bai-font">No Record Found</Box>
                </Box>)}
            </Box>
          </TabPanel>
        </Paper>
      </Box>
    </div>
  );
}
